module.exports = __webpack_public_path__ + "static/img/USC_Marshall_CurriculumMap_2023_BUAI_R3.68c34d3.png";


//////////////////
// WEBPACK FOOTER
// ./static/USC_Marshall_CurriculumMap_2023_BUAI_R3.png
// module id = eApo
// module chunks = 1